import React from 'react';

const VARIANT_CLASS = {
  default: 'lex-badge--default',
  success: 'lex-badge--success',
  error: 'lex-badge--error',
  warning: 'lex-badge--warning',
  premium: 'lex-badge--premium',
  neutral: 'lex-badge--neutral',
};

/**
 * Small status label — semantic color variants.
 */
const Badge = ({ children, variant = 'default', className = '' }) => {
  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.default;
  return (
    <span className={`lex-badge ${variantClass} ${className}`.trim()}>
      {children}
    </span>
  );
};

export default Badge;
